import { CONSTANTS, HELPERS } from '@/utils';

import { SERVICE_AUTH } from '@/services';
import { queryClient } from '@/utils/queryClient';
import store from 'store';
import { ACTION_ACTIVITY } from '../activity/activity.action';
import { TYPES_AUTH } from './auth.types';

const register = (data, successCallback, errorCallback) => {
  return (dispatch) => {
    dispatch(ACTION_ACTIVITY.showTopLoadingBar(true));

    SERVICE_AUTH.register(data, (res) => {
      dispatch(ACTION_ACTIVITY.showTopLoadingBar(false));

      if (res.success) {
        if (successCallback) successCallback();
      } else {
        HELPERS.showNotificationServiceError(res.error);
        if (errorCallback) errorCallback();
      }
    });
  };
};

const forgotPassword = (data, callback) => {
  return (dispatch) => {
    dispatch(ACTION_ACTIVITY.showTopLoadingBar(true));
    dispatch({ type: TYPES_AUTH.FORGOT_PASSWORD_LOADING, isLoading: true });

    SERVICE_AUTH.forgotPassword(data, (res) => {
      dispatch(ACTION_ACTIVITY.showTopLoadingBar(false));
      dispatch({ type: TYPES_AUTH.FORGOT_PASSWORD_LOADING, isLoading: false });
      if (res.success) callback(res.payload);
      else HELPERS.showNotificationServiceError(res.error);
    });
  };
};

const resetPassword = (password, confirmPassword, params, callback) => {
  return (dispatch) => {
    dispatch(ACTION_ACTIVITY.showTopLoadingBar(true));
    dispatch({ type: TYPES_AUTH.RESET_PASSWORD_LOADING, isLoading: true });

    SERVICE_AUTH.resetPassword(password, confirmPassword, params, (res) => {
      dispatch(ACTION_ACTIVITY.showTopLoadingBar(false));
      dispatch({ type: TYPES_AUTH.RESET_PASSWORD_LOADING, isLoading: false });

      if (res.success) callback(res.payload);
      else HELPERS.showNotificationServiceError(res.error);
    });
  };
};

const changePassword = (oldPassword, newPassword, callback) => {
  return (dispatch) => {
    dispatch(ACTION_ACTIVITY.showTopLoadingBar(true));
    dispatch({ type: TYPES_AUTH.CHANGE_PASSWORD_LOADING, isLoading: true });

    SERVICE_AUTH.changePassword(oldPassword, newPassword, (res) => {
      dispatch(ACTION_ACTIVITY.showTopLoadingBar(false));
      dispatch({ type: TYPES_AUTH.CHANGE_PASSWORD_LOADING, isLoading: false });

      if (res.success && callback) {
        callback(res.payload);
      } else if (!res.success) {
        HELPERS.showNotificationServiceError(res.error);
      }
    });
  };
};

const login = (data, callback, errorCallback) => {
  return (dispatch) => {
    dispatch(ACTION_ACTIVITY.showTopLoadingBar(true));

    SERVICE_AUTH.login(data, (res) => {
      dispatch(ACTION_ACTIVITY.showTopLoadingBar(false));

      if (res.success) {
        // Set token in local storage
        store.set(CONSTANTS.AUTH_TOKEN, res.payload.token);

        // Dispatch login action to update the Redux store
        dispatch({
          type: TYPES_AUTH.LOGIN,
          profile: res.payload.profile,
          token: res.payload.token,
        });

        if (queryClient) {
          queryClient.invalidateQueries(['events']);
          queryClient.invalidateQueries(['courses']);
          queryClient.invalidateQueries(['profile']);
          queryClient.invalidateQueries(['transactions']);
          queryClient.invalidateQueries(['cart']);
        }

        if (callback) callback(res);
      } else {
        HELPERS.showNotificationServiceError(res.error);
        if (errorCallback) errorCallback(res.error);
      }
    });
  };
};

const emailActivation = (email, token, callback) => {
  return (dispatch) => {
    dispatch(ACTION_ACTIVITY.showTopLoadingBar(true));

    SERVICE_AUTH.emailActivation(email, token, (res) => {
      dispatch(ACTION_ACTIVITY.showTopLoadingBar(false));
      if (res.success) callback();
      else HELPERS.showNotificationServiceError(res.error);
    });
  };
};

const logout = () => {
  return (dispatch) => {
    if (queryClient) {
      // Clear all queries on logout
      queryClient.clear();
    }

    dispatch({ type: TYPES_AUTH.LOGOUT });

    store.clearAll();
    store.remove(CONSTANTS.AUTH_TOKEN);
  };
};

const handleAuthExpiry = (message = 'Sesi Anda sudah berakhir') => {
  return (dispatch) => {
    dispatch(logout());

    dispatch({
      type: TYPES_AUTH.AUTH_EXPIRED,
      payload: { message, shouldRedirect: true },
    });
  };
};

const clearAuthRedirect = () => {
  return { type: TYPES_AUTH.CLEAR_AUTH_REDIRECT };
};

export const ACTION_AUTH = {
  login,
  logout,
  handleAuthExpiry,
  clearAuthRedirect,
  register,
  forgotPassword,
  resetPassword,
  changePassword,
  emailActivation,
};
